import { HttpService } from '../../services/HttpService';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import * as Constants from './Constants';
import { apiUrls } from '../../constants/apiUrl';
import { logError, FE_API_ERROR } from '../../services/loggerService';
import {
  getAPPID,
  setSession,
  getSession,
  isBulkQualIndicator,
  getIntendType,
  isSequentialFlow,
  isWHW,
  setCookie,
  isJointTransactionFlow,
} from '../../components/common/Helpers';
import { hideLoader } from '../../components/common/Loader/action';
import { store } from '../../configureStore';
import { saveItemToStore } from '../../utils/sessionStorage';

export const dawCoupon = (data) => ({
  type: 'DAW_COUPON',
  value: data,
});

export const getDataFromApi = (data) => ({
  type: Constants.GET_DATA_FROM_API,
  data,
});
export const getUpdateCart = (data) => ({
  type: Constants.UPDATE_CART,
  data,
});
export const intendType = () => {
  let intendTypeval = '';
  intendTypeval = getSession('FlowType');
  return intendTypeval;
};

export const bundleInstallType = () => {
  const bundleType = {
    installType: '',
    depletionType: '',
  };
  let i = 0;
  let lqResp = getSession('LQResponse');
  lqResp = JSON.parse(lqResp);
  if (lqResp && lqResp.output && lqResp.output.bundleDetails !== null && lqResp.output.bundleDetails !== undefined) {
    if (lqResp.output.bundleDetails.length > 1) {
      for (i = 0; i < lqResp.output.bundleDetails.length; i++) {
        if (lqResp.output.bundleDetails[i].type.toLowerCase() === 's') {
          bundleType.depletionType = 'F';
          bundleType.installType = lqResp.output.bundleDetails[i].bundleName;
        }
      }
    } else if (lqResp.output.bundleDetails.length === 1) {
      if (lqResp.output.bundleDetails[i].type.toLowerCase() === 's') {
        bundleType.depletionType = 'F';
        bundleType.installType = lqResp.output.bundleDetails[i].bundleName;
      } else {
        bundleType.installType = lqResp.output.bundleDetails[0].bundleName;
        bundleType.depletionType = 'O';
      }
    } else if (lqResp.output.bundleDetails.length === 0 && getSession('isCBandQual') === 'Y') {
      bundleType.depletionType = 'F';
    } else if (
      lqResp.output.bundleDetails.length === 0 &&
      lqResp.output.launchType !== null &&
      lqResp.output.launchType !== undefined &&
      lqResp.output.launchType === '4GH'
    ) {
      bundleType.depletionType = 'F';
    }
  } else if (
    lqResp &&
    lqResp.output &&
    lqResp.output.launchType !== null &&
    lqResp.output.launchType !== undefined &&
    lqResp.output.launchType === '4GH'
  ) {
    bundleType.depletionType = 'F';
  } else if (lqResp && lqResp.output && lqResp.output.qualifiedCBand) {
    bundleType.depletionType = 'F';
  } else if (getSession('isCBandQual') === 'Y') {
    bundleType.depletionType = 'F';
  } else if (lqResp && lqResp.tanglewoodQualified && lqResp.bundleDetails?.length > 0) {
    bundleType.depletionType = 'O';
    bundleType.installType = lqResp.bundleDetails[0].bundleName;
  }
  return bundleType;
};

export const getCheckAvilablityAPI = (postData) => {
  // const headers = {
  //   "Content-Type": "application/json",
  //   "channelId": 'VZW-DOTCOM',
  //   "x-soe-apikey": "uFWjzl4du5e46whYg73iCGqriX2l62C9"
  // };

  const apiURL = `${getSecureBaseUrl()}${apiUrls().updateCartOnAddons}`;
  // return HttpService.post(apiURL, postData, { headers });
  const apiResponse = HttpService.post(apiURL, postData);
  Promise.all([apiResponse]).then((res) => {
    if (res[0] && res[0].data && res[0].status === 200) {
      // store.dispatch({ type: constants.ASYNC_FETCH_SUCCESS });
      return res[0].data;
    }
    logError('getCheckAvilablityAPI', res[0].errors, FE_API_ERROR);
    return null;
  });
};

export const partnerCheckAvlAPI = (postData) => {
  const apiURL = `${getSecureBaseUrl()}${apiUrls().partnerCheckAvlUrl}`;
  const reqData = {
    address: postData,
    includeCband: true,
    cBandOnly: false,
  };
  const apiResponse = HttpService.post(apiURL, reqData);
  Promise.all([apiResponse]).then((res) => {
    if (res[0] && res[0].data && res[0].status === 200) {
      store.dispatch({ type: Constants.PARTNER_AVL, response: res[0].data });
      window.location.href = apiUrls().redirect5Ghome;
      return res[0].data;
    }
    logError('partnerCheckAvlAPI', FE_API_ERROR);
    return null;
  });
  // return HttpService.post(apiURL, reqData).then((res) => {
  //   if ((res && res.data) && res.status === 200) {
  //     store.dispatch({ type: Constants.PARTNER_AVL, response: res.data });
  //     window.location.href = apiUrls().redirect5Ghome;
  //     return res.data;
  //   }
  //   logError('partnerCheckAvlAPI', FE_API_ERROR);
  //   return null;
  // });
};

export const getUpdateCartAPI = (inputData, flowType) => {
  // const headers = {
  //   "Content-Type": "application/json",
  //   "channelId": 'VZW-DOTCOM',
  //   "x-soe-apikey": "uFWjzl4du5e46whYg73iCGqriX2l62C9"
  // };
  const bundleInfo = bundleInstallType();
  const action = inputData && inputData.data && 'actionType' in inputData.data ? inputData.data.actionType : '';
  let postData = {};
  let value;
  const { search } = window.location;
  const params = new URLSearchParams(search);
  const addPlan = params.get('addplan') === 'false';
  if (addPlan) {
    value = 'addPlan';
  }
  if (getAPPID() === 'AAL' && isBulkQualIndicator()) {
    if (flowType === 'EUP_LTE') {
      postData = {
        cartInfo: {
          clientAppName: '',
          bulkQualIndicator: 'Y',
          accountNumber: '',
          cartCreator: '',
          processingMTN: '',
          processStep: 'OrderNow',
          processAction: 'DeviceAndPlan',
          intendType: 'EUP_LTE',
          bundleInstallType: '',
        },
        data: {
          lines: [
            {
              depletionType: 'F',
            },
          ],
        },
      };
    } else {
      postData = getCartUpdtApiObj(bundleInfo, action);
      postData.cartInfo.bulkQualIndicator = 'Y';
    }
  } else if (flowType === 'EUP_LTE') {
    postData = {
      cartInfo: {
        clientAppName: '',

        accountNumber: '',
        cartCreator: '',
        processingMTN: '',
        processStep: 'OrderNow',
        processAction: 'DeviceAndPlan',
        intendType: 'EUP_LTE',
        bundleInstallType: '',
        ...(isSequentialFlow() && getAPPID() === 'NSE' ? { isSequentialComboOrder: true } : {}),
      },
      data: {
        lines: [
          {
            depletionType: 'F',
          },
        ],
      },
    };
  } else {
    postData = getCartUpdtApiObj(bundleInfo, action);
  }
  const apiURL = `${getSecureBaseUrl()}${apiUrls().updateCartOnAddons}`;
  // return HttpService.post(apiURL, postData, { headers });
  const apiResponse = HttpService.post(apiURL, postData);
  // debugger;
  const isLoggedIn = getAPPID() === 'AAL';
  // debugger;
  Promise.all([apiResponse]).then((res) => {
    // alert("HELLO", res[0]);
    store.dispatch({ type: 'CLEAR_COUPON_VALUE' });
    if (res[0] && res[0].data && res[0].status === 200 && !res[0].data?.errors) {
      // store.dispatch({ type: constants.ASYNC_FETCH_SUCCESS });
      if (flowType === 'EUP_LTE') {
        setSession('EUPUpgrade', true);
      }
      const existingCase =
        res[0].data &&
        res[0].data.serviceBody &&
        res[0].data.serviceBody.serviceResponse &&
        res[0].data.serviceBody.serviceResponse.context &&
        res[0].data.serviceBody.serviceResponse.context.customerInfo &&
        res[0].data.serviceBody.serviceResponse.context.customerInfo.existingCase
          ? res[0].data.serviceBody.serviceResponse.context.customerInfo.existingCase
          : '';
      const processStep =
        res[0].data &&
        res[0].data.serviceBody &&
        res[0].data.serviceBody.serviceResponse &&
        res[0].data.serviceBody.serviceResponse.context &&
        res[0].data.serviceBody.serviceResponse.context.contextInfo &&
        res[0].data.serviceBody.serviceResponse.context.contextInfo.processStep
          ? res[0].data.serviceBody.serviceResponse.context.contextInfo.processStep
          : '';
      const processMTNList =
        res[0].data &&
        res[0].data.serviceBody &&
        res[0].data.serviceBody.serviceResponse &&
        res[0].data.serviceBody.serviceResponse.context &&
        res[0].data.serviceBody.serviceResponse.context.processMTNList
          ? res[0].data.serviceBody.serviceResponse.context.processMTNList
          : '';
      const completedprocessSteps = processMTNList.length > 0 && processMTNList[0]?.completedprocessSteps;
      const pastDue =
        res[0].data &&
        res[0].data.serviceBody &&
        res[0].data.serviceBody.serviceResponse &&
        res[0].data.serviceBody.serviceResponse.context &&
        res[0].data.serviceBody.serviceResponse.context.contextInfo &&
        res[0].data.serviceBody.serviceResponse.context.contextInfo.pastDueBalance
          ? res[0].data.serviceBody.serviceResponse.context.contextInfo.pastDueBalance
          : '';
      const pastDueBalance =
        res[0].data &&
        res[0].data.serviceBody &&
        res[0].data.serviceBody.serviceResponse &&
        res[0].data.serviceBody.serviceResponse.context &&
        res[0].data.serviceBody.serviceResponse.context.contextInfo &&
        res[0].data.serviceBody.serviceResponse.context.contextInfo.pastDueBalanceAmount
          ? res[0].data.serviceBody.serviceResponse.context.contextInfo.pastDueBalanceAmount
          : '';
      const reasonCode =
        res[0].data &&
        res[0].data.serviceBody &&
        res[0].data.serviceBody.serviceResponse &&
        res[0].data.serviceBody.serviceResponse.context &&
        res[0].data.serviceBody.serviceResponse.context.contextInfo &&
        res[0].data.serviceBody.serviceResponse.context.cartInfo.orderRestrictions?.accountLevelChangeEligibility
          ? res[0].data.serviceBody.serviceResponse.context.cartInfo?.orderRestrictions?.accountLevelChangeEligibility
          : '';
      const reasonCodevalue = reasonCode.length > 0 && reasonCode[0]?.reasonCode;
      setSession(
        'cartExist',
        res[0].data &&
          res[0].data.serviceBody &&
          res[0].data.serviceBody.serviceResponse &&
          res[0].data.serviceBody.serviceResponse.context &&
          res[0].data.serviceBody.serviceResponse.context.cartInfo &&
          res[0].data.serviceBody.serviceResponse.context.cartInfo.cartExist
          ? res[0].data.serviceBody.serviceResponse.context.cartInfo.cartExist
          : '',
      );
      store.dispatch({ type: 'CLEAR_COUPON_VALUE' });
      if (pastDue === 'true' || pastDue === true) {
        setSession('pastDueBalAmount', pastDueBalance);
        hideLoader(store.dispatch);
        window.location.href = apiUrls().accFailurl;
        return res[0].data;
      }
      if (reasonCodevalue === 'COLLECTIONS_IND') {
        hideLoader(store.dispatch);
        window.location.href = apiUrls().collections_INDurl;
        return res[0].data;
      }
      if (reasonCodevalue === 'CASHONLY_IND') {
        hideLoader(store.dispatch);
        window.location.href = apiUrls().cashOnlyUrl;
        return res[0].data;
      }
      if (reasonCodevalue === 'FRAUD_INDICATOR_X') {
        hideLoader(store.dispatch);
        window.location.href = apiUrls().ONFraudOrderUrl;
        return res[0].data;
      }
      store.dispatch({ type: 'GET_NPA_NXX_SUCCESS', response: '' });
      if ((existingCase === 'true' || existingCase === true) && params.get('fcc') !== 'y') {
        if (value && value === 'addPlan') {
          if (getSession('isCBandFlow') === 'Y') {
            window.location.href = apiUrls().redirectCBandPlans;
            return res[0].data;
          }
          window.location.href = apiUrls().redirectCBandPlans;
          return res[0].data;
        }
        if (isLoggedIn) {
          setSession('ExistingCase', existingCase);
          window.location.href = processStepRedirection(processStep, completedprocessSteps);
          return res[0].data;
        }
        window.location.href = processStepRedirection(processStep, completedprocessSteps);
        return res[0].data;
      }
      if (action && action === 'Resume' && params.get('fcc') !== 'y') {
        store.dispatch({ type: 'VALIDATECART_RESPONSE', response: '' });
        store.dispatch({ type: 'CLEAR_COUPON_VALUE' });
        window.location.href = processStepRedirection(processStep, completedprocessSteps);
        return res[0].data;
      }
      setSession('ONResponse', JSON.stringify(res[0].data));
      setTimeout(() => {
        hideLoader(store.dispatch);
      }, 3000);
      if (getSession('isCBandFlow') === 'Y' && params.get('WHW') !== 'Y' && params.get('fcc') !== 'y') {
        window.location.href = apiUrls().redirectCBandPlans;
        return res[0].data;
      }
      if (isWHW()) {
        window.location.href = apiUrls().redirectShipping;
        return res[0].data;
      }
      if (getSession('fcc') === 'true' || params.get('fcc') === 'y' || getSession('fcc') === true) {
        setSession('fcc', true);
        setCookie('fcc', true);
        window.location.href = apiUrls().redirectBroadBandFacts;
        return res[0].data;
      }
      window.location.href = apiUrls().redirectCBandPlans;
      return res[0].data;
    }
    if (
      res &&
      res[0] &&
      res[0].data &&
      res[0].data.errors &&
      res[0].data.errors[0] &&
      res[0].data.errors[0].message &&
      res[0].data.errors[0].message.indexOf('FiveG qualified address is not available') > -1
    ) {
      window.location.href = `${apiUrls().redirect5Ghome}?se=r`; // se=r means sessionexpiry=redirect
    }
    if (res[0]?.status !== 200 || res[0]?.data?.errors) {
      // debugger;
      store.dispatch({ type: Constants.UPDATE_CART_FAIL_RESPONSE, response: res[0] });
      store.dispatch({ type: Constants.UPDATE_CART_FAIL, response: true });
    }
    logError('getUpdateCartAPI', res[0].errors, FE_API_ERROR);
    setTimeout(() => {
      hideLoader(store.dispatch);
    }, 3000);
    return null;
  });
};
export const getCartUpdtApiObj = (bundleInfo, action) => {
  const postData = action
    ? {
        cartInfo: {
          clientAppName: 'VZW-DOTCOM',
          // bulkQualIndicator: 'Y',
          accountNumber: '',
          cartCreator: '',
          processingMTN: '',
          processStep: 'OrderNow',
          processAction: 'DeviceAndPlan',
          action,
          intendType: `${getIntendType()}`,
          bundleInstallType: bundleInfo && bundleInfo.installType ? bundleInfo.installType : null,
          ...(isSequentialFlow() && getAPPID() === 'NSE' ? { isSequentialComboOrder: true } : {}),
          ...(isJointTransactionFlow() ? { jointCombo: 'Y' } : {}),
        },
        data: {
          lines: [
            {
              depletionType: bundleInfo.depletionType,
            },
          ],
        },
      }
    : {
        cartInfo: {
          clientAppName: 'VZW-DOTCOM',
          // bulkQualIndicator: 'Y',
          accountNumber: '',
          cartCreator: '',
          processingMTN: '',
          processStep: 'OrderNow',
          processAction: 'DeviceAndPlan',
          intendType: `${getIntendType()}`,
          bundleInstallType: bundleInfo && bundleInfo.installType ? bundleInfo.installType : null,
          ...(isSequentialFlow() && getAPPID() === 'NSE' ? { isSequentialComboOrder: true } : {}),
          ...(isJointTransactionFlow() ? { jointCombo: 'Y' } : {}),
        },
        data: {
          lines: [
            {
              depletionType: bundleInfo.depletionType,
            },
          ],
        },
      };

  return postData;
};
export const processStepRedirection = (nextStep) => {
  // , completedSteps) => {
  // sessionStorage.setItem('isResumeFlow', true);
  saveItemToStore('isResumeFlow', true);
  setSession('ResumeCase', true);
  switch (nextStep) {
    case 'Accessories':
      return apiUrls().redirectAddons;
    case 'ShoppingCart':
      // if (completedSteps && completedSteps.length > 0 && completedSteps.includes('NumberSelection')) {
      //   return apiUrls().redirectCart;
      // }
      return apiUrls().redirectCart;
    case 'InstallType':
      return apiUrls().redirectSetup;
    default:
      // return getSession('isCBandFlow') === 'Y' ? apiUrls().redirectCBandPlans : apiUrls().redirectHomePlans;
      return apiUrls().redirectCBandPlans;
  }
};

export const getRedirectToAPI = () => {
  const apiURL = `${getSecureBaseUrl()}${apiUrls().reDirectToUrl}`;
  const reqData = {};
  const apiResponse = HttpService.post(apiURL, reqData);
  Promise.all([apiResponse]).then((res) => {
    if (res[0] && res[0].data && res[0].status === 200) {
      return res[0].data;
    }
    logError('getRedirectToAPI', res[0].errors, FE_API_ERROR);
    return null;
  });
};

export const getRedirectAPI = () => {
  const apiURL = `${getSecureBaseUrl()}${apiUrls().reDirectToUrl}`;
  const reqData = {};
  const apiResponse = HttpService.post(apiURL, reqData);
  Promise.all([apiResponse]).then((res) => {
    if (res && res[0] && res[0].data && res[0].data.redirectUrl) {
      window.location.href = res[0].data.redirectUrl;
    }
    logError('getRedirectAPI', FE_API_ERROR);
    return null;
  });
};

export const getData = () => HttpService.get(`${getSecureBaseUrl()}${apiUrls().basetemplateurl}`);

export const pushMessageCall = (data) => ({
  type: Constants.PUSH_MESSAGE_CALL,
  data,
});

export const pushMessageApiCall = () => {
  const postData = {
    type: 'coverageLead',
  };
  const apiURL = `${getSecureBaseUrl()}${apiUrls().pushMessage}`;
  return HttpService.post(apiURL, postData);
};
